//返回双数
export const formatNumber = n => {
  n = n.toString();
  return n[1] !== undefined ? n : '0' + n;
};

const onehourMs = 60 * 60 * 1000; //1小时毫秒数
const onedayMs = 24 * onehourMs;  //1天毫秒数

/**
 * dateFormat 日期格式化
 *
 * @param {*} time 时间戳
 * @param {*} format 格式，默认 "yyyy-MM-dd"
 * @param {*} opt 配置
 *
 * 格式化规则:
 * YYYY YY 年
 * MM MM M 月
 * DD D 日
 * HH H 时
 * mm m 分
 * ss s 秒
 * SSS SS S 毫秒
 * QQ Q 季度
 * ddd dd d 星期几
 */
 export function dateFormat(time, format = 'YYYY-MM-DD') {
  if (!time) return '';
  const date = new Date(time);

  // 格式化年
  if (/(YY+)/.test(format)) {
    const rule = format.match(/(YY+)/)[1];
    const text = '' + date.getFullYear();
    format = format.replace(rule, text.slice(4 - rule.length));
  }

  // 格式化 月、日、季度、星期几
  const o1 = {
    'M+': date.getMonth() + 1, //月
    'D+': date.getDate(), //日
    'Q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'd+': date.getDay() + 1 //星期几
  };
  Object.keys(o1).forEach((key) => {
    if (new RegExp(`(${key})`).test(format)) {
      const rule = format.match(new RegExp(`(${key})`))[1];
      const text = '' + o1[key];
      format = format.replace(rule, rule.length > 1 ? ('0' + text).slice(-2) : text);
    }
  });

  // 格式化 时、分、秒
  const o2 = {
    'H+': date.getHours(), //时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds() //秒
  };

  Object.keys(o2).forEach((key) => {
    if (new RegExp(`(${key})`).test(format)) {
      const rule = format.match(new RegExp(`(${key})`))[1];
      const text = '' + o2[key];
      format = format.replace(rule, rule.length > 1 ? ('0' + text).slice(-2) : text);
    }
  });

  // 格式化毫秒
  if (/(S+)/.test(format)) {
    const rule = format.match(/(S+)/)[1];
    const text = ('000' + date.getMilliseconds()).slice(-3);
    format = format.replace(rule, text.slice(0, rule.length));
  }
  
  // console.log('format', format);
  return format;
}

// let testTime = 1443855705567;
// dateFormat(testTime, 'YYYY-MM-DD HH:mm:ss:SSS 本周第dd天 第QQ季度');
// // 2015-10-03 15:01:45:567 本周第07天 第04季度

// dateFormat(testTime, 'YY年M月D日 HH:m:s 星期d 第Q季度');
// // 15年10月3日 15:1:45 星期7 第4季度


// 昨天
export function yesterDay(){
  const nowTime = (new Date()).getTime();
  const targetTime = nowTime - onedayMs;
  return new Date(targetTime);
}

// 获取当前日期是当年的第几周
// export function getWeek(date){
//   date = date ? new Date(date) : new Date();
//   const firstDayOfYear = new Date(date.getFullYear(), 0, 1);  //当年第一天
//   const oneDayMs = 24 * 60 * 60 * 1000;
//   const daysSinceFirstDayOfYear = Math.floor((date - firstDayOfYear) / oneDayMs);
//   const firstDayOfWeek = firstDayOfYear.getDay(); // 第一天所在的星期（0-6，0表示星期日）
//   console.log(daysSinceFirstDayOfYear, firstDayOfWeek);
  
//   let week = Math.floor((daysSinceFirstDayOfYear + firstDayOfWeek) / 7) + 1;
//   console.log('week', week);
  
//   if (firstDayOfWeek === 0) week -= 1; // 如果第一天是星期日，则当前星期数减一

//   return week;
// }

export function getYearWeek(endDate){
  endDate = endDate ? new Date(endDate) : new Date();
  const beginDate = new Date(endDate.getFullYear(), 0, 1);  //本年的第一天
  const oneDayMs = 24 * 60 * 60 * 1000;

  //星期从0-6,0代表星期天，6代表星期六
  let endWeek = endDate.getDay();
  if (endWeek == 0) endWeek = 7;
  let beginWeek = beginDate.getDay();
  if (beginWeek == 0) beginWeek = 7;
  
  //计算两个日期的天数差
  const millisDiff = endDate.getTime() - beginDate.getTime();
  const dayDiff = Math.floor((millisDiff + (beginWeek - endWeek) * oneDayMs) / oneDayMs);
  return Math.ceil(dayDiff / 7) + 1;
}


/**
 * 
 * @param {*} time 毫秒差值 
 * @param {*} isShowAll 是否完全展示
 * @param {*} showLevel 展示等级
 * @param {*} isPadZero 是否补零
 * @param {*} isFormatHour 是否格式化小时 
 * @param {*} isFormatMinutes 是否格式化分
 * @param {*} isFormatSeconds 是否格式化秒 
 * @param {*} seq 分隔符
 * @param {*} stopFirstZero 首位是否禁止为0
 * @returns 
 */
export function formatSeconds(time, opt={}){
  if ([undefined, null, ''].includes(time)) return '0';
  const {showLevel} = opt;

  const seq = opt.seq || [':', ":"];
  const diffTime = time;
  
  
  let result = '';
  // let day = Number.parseInt(diffTime / 1000/60/60/24);
  const hour = Number.parseInt(diffTime / 1000 / 60 / 60);
  const minutes = Number.parseInt(diffTime / 1000 / 60 % 60);
  const seconds = Number.parseInt(diffTime / 1000 % 60);

  // 补零
  const hourFormat = opt.isFormatHour || opt.isPadZero ? formatNumber(hour) : hour.toString();
  const minutesFormat = opt.isFormatMinutes || opt.isPadZero ? formatNumber(minutes) : minutes.toString();
  const secondsFormat = opt.isFormatSeconds || opt.isPadZero ? formatNumber(seconds) : seconds.toString();

  // 添加分隔
  let hourSeq = '', minutesSeq = '', secondsSeq = '';
  if (Array.isArray(seq) && seq.length > 0){
    hourSeq += `${hourFormat}${seq[0] || ''}`;
    minutesSeq += `${minutesFormat}${seq[1] || ''}`;
    secondsSeq += `${secondsFormat}${seq[2] || ''}`;
  }
  // console.log(1, hourSeq, minutesSeq, secondsSeq);
  // 完全展示
  if (opt.isShowAll || showLevel === 1) return `${hourSeq}${minutesSeq}${secondsSeq}`;

  // 不完全展示
  if (hour > 0 || showLevel === 1) result += hourSeq;
  if (hour > 0 || minutes > 0 || [1, 2].includes(showLevel)) result += minutesSeq;
  if (hour > 0 || minutes > 0 || seconds > 0 || [1, 2, 3].includes(showLevel)) result += secondsSeq;

  // 移除首位零
  if (opt.stopFirstZero){
    const resultFirst = result.slice(0, 1);
    if (resultFirst === '0') return result.slice(1);
  }
  // console.log('result', result, hour, minutes, seconds);
  
  return result;
}


/**
 * 根据生日字符串计算周岁年龄
 * @param {string} birthday - 生日格式：YYYY-MM-DD
 * @returns {number} 周岁年龄
 */
export function getAgeFromBirth(birthday) {
  
  if (!birthday) return '';
  const today = new Date(); // 获取今天的日期
  const birthDate = new Date(birthday); // 转换生日为日期对象
  
  let age = today.getFullYear() - birthDate.getFullYear();  // 计算年份差
  const monthDiff = today.getMonth() - birthDate.getMonth();  // 计算月份差
  
  // 如果还没到今年的生日，年龄减1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age --;
  }
  if (age < 0) return 0;
  return age;
}

// 获取一天的开始
export function getDayStart(date){
  date = date ? new Date(date) : new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
// 获取一天的结束
export function getDayEnd(date){
  date = date ? new Date(date) : new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}